import { observer } from 'mobx-react';
import * as React from 'react';
import {
  AreaInput,
  Button,
  DateInput,
  FormCell,
  Icon,
  IconSize,
  IconType,
  NumberInput,
  Select,
  TextInput,
  Grid,
  FlexRow,
  Header3Text,
} from 'ui-toolkit';
import { judgementLienDocumentOptions } from '../../documentTypes';
import { ISearchReportChange } from '../../services/SearchReportService';
import { IJudgementData } from '../../../ui-toolkit/orders/interfaces/titleReport/IJudgement';

// tslint:disable:jsx-no-lambda TODO: remove this tslint disable

interface IProps {
  data: IJudgementData[];
  error?: any;
  dataPath: string;
  title?: string;
  onFormChange: (dataPath: string, newData: ISearchReportChange, error?: string | null | undefined) => void;
  onAddNewItem: (dataPath: string) => void;
  onDeleteItem: (dataPath: string, index: number) => void;
  validateFormData: (path: string) => void;
}

export const Judgement = observer(
  class Judgement extends React.Component<IProps, {}> {
    public static defaultProps: Partial<IProps> = {
      title: 'Documents',
    };

    public render() {
      const dataLen = this.props.data.length;

      return (
        <React.Fragment>
          {this.props.data.map((judgement: IJudgementData, index: number) => {
            return (
              <React.Fragment key={`judgement-information-${index}`}>
                <FlexRow justifyContent={'space-between'}>
                  <Header3Text>Judgement/Lien No {index + 1}</Header3Text>
                  {this.props.data.length > 1 ? (
                    <Button
                      intent="ghost"
                      isInline
                      onClick={() => this.props.onDeleteItem('judgementInformation.judgements', index)}
                    >
                      <Icon type={IconType.Remove} size={IconSize.Small} />
                    </Button>
                  ) : null}
                </FlexRow>

                <Grid columnCount={2}>
                  <FormCell errorText={this.props.error[`deedInformation[${index}].documentType`]} label="Type">
                    <Select
                      isClearable={true}
                      value={judgementLienDocumentOptions.filter((opt) => opt.value === judgement.judgementType)}
                      placeholder="Select"
                      options={judgementLienDocumentOptions}
                      onChange={(value: any, error: any) =>
                        this.onDocumentTypeChange(index, value && value.value, null)
                      }
                    />
                  </FormCell>
                  {judgement.judgementType === 'other' ? (
                    <TextInput
                      value={judgement.otherJudgementType}
                      errorText={this.props.error[`judgementInformation.judgements[${index}].otherJudgementType`]}
                      label="Other type"
                      isRequired={judgement.judgementType === 'other'}
                      placeholder="Add type name"
                      onChange={(value, error) => this.onChange('otherJudgementType', index, value, error)}
                      onBlur={() =>
                        this.props.validateFormData(`judgementInformation.judgements[${index}].otherJudgementType`)
                      }
                    />
                  ) : null}
                </Grid>
                <Grid columnCount={2}>
                  <TextInput
                    value={judgement.creditorName}
                    label="Creditor name"
                    placeholder="Ex. Appliance Store"
                    onChange={(value, error) => this.onChange('creditorName', index, value, error)}
                  />
                  <TextInput
                    value={judgement.debtorName}
                    label="Debtor name"
                    placeholder="Ex. Beyonce Knowles"
                    onChange={(value, error) => this.onChange('debtorName', index, value, error)}
                  />
                  <NumberInput
                    value={judgement.amount}
                    label="Amount"
                    prefix="$"
                    placeholder="XXX,XXX,XXX.XX"
                    decimalScale={2}
                    onChange={(value, error) => this.onChange(`amount`, index, value, error)}
                    mode="currency"
                    thousandSeparator={true}
                  />
                  <DateInput
                    value={judgement.fileDate || null}
                    errorText={this.props.error[`judgementInformation.judgements[${index}].fileDate`]}
                    label="File date"
                    onChange={(value) => this.onChange(`fileDate`, index, value.value)}
                  />
                  <TextInput
                    value={judgement.book}
                    label="Book/page"
                    placeholder="XXXX"
                    className="card--row-element"
                    onChange={(value, error) => this.onChange(`book`, index, value, error)}
                  />
                  <AreaInput
                    value={judgement.additionalInformation}
                    label="Additional information"
                    rows={1}
                    placeholder="Please include additional information here"
                    className="card--row-element"
                    onChange={(value, error) => this.onChange(`additionalInformation`, index, value, error)}
                  />
                </Grid>
                {index !== dataLen - 1 && <hr className="card-horizontal-separator" />}
              </React.Fragment>
            );
          })}
          <div>
            <Button intent="ghost" isInline onClick={(e) => this.props.onAddNewItem(`judgementInformation.judgements`)}>
              + Add Judgement/Lien
            </Button>
          </div>
        </React.Fragment>
      );
    }

    private onDocumentTypeChange = (index: number, value: string, error: string | null | undefined) => {
      this.onChange(`judgementType`, index, value, error);
      if (value !== 'other') {
        this.onChange(`otherJudgementType`, index, null, null);
      }
    };

    private onChange = (itemDataPath: string, itemIndex: number, newValue: any, error?: string | null | undefined) => {
      this.props.onFormChange(
        this.props.dataPath,
        {
          data: newValue,
          dataPath: itemDataPath,
          index: itemIndex,
        },
        error
      );
    };
  }
);
